import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React, { useState, useCallback, useRef, useEffect } from 'react';
import CustomFilters from './customFilters';
import CustomFilterModalComponent from './component';
import { Modal, Button, Icon, Input, Collapse, Tabs, Menu, Space } from 'udesk-ui';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import Ellipsis from 'src/components/common/Ellipsis';
import _isEmpty from 'lodash-es/isEmpty';
import { SortTypeMap } from './const';
import './style.scss';

const { Panel } = Collapse;
const { TabPane } = Tabs;

const DraggableComponent = (props) => {
    const [, drag] = useDrag({
        item: { type: 'cards', name: `${props.name}`, ...props },
        end: (item, monitor) => {
            if (!monitor.didDrop()) {
                delete item.index;
            }
        },
    });
    return (
        <div ref={drag} className="react-qa-custom-filter-body-left-info-field">
            <Icon type="list-check" />
            <span title={props.name} className="react-qa-custom-filter-body-left-info-text">
                {props.name}
            </span>
        </div>
    );
};
const MyDropTarget = (props) => {
    let ref = useRef(null);
    let customFiltersRef = useRef(null);
    let [list, setList] = useState(props.displayConditionList || []);

    const customFiltersRefed = useCallback(() => {
        customFiltersRef &&
            customFiltersRef.current &&
            (customFiltersRef.current.privates.dirtyFullConditions = null);
    }, []);

    const filterContidionChanged = useCallback(
        (condition) => {
            setList(condition);
            props.filterContidionChange && props.filterContidionChange(condition);
        },
        [props]
    );

    const [, drop] = useDrop({
        accept: 'cards',
        drop: (item, monitor) => {
            customFiltersRefed();

            const temp = list || [];

            setList([...temp, { field: item.id, value: SortTypeMap.DESCEND }]);
            props.filterContidionChange &&
                props.filterContidionChange([
                    ...temp,
                    { field: item.id, value: SortTypeMap.DESCEND },
                ]);
        },
    });

    useEffect(() => {
        if (props.displayConditionList.length === 0) {
            customFiltersRefed();
            setList([]);
        } else {
            setList(props.displayConditionList);
        }
    }, [customFiltersRefed, props.displayConditionList]);

    drop(ref);
    return (
        <div ref={ref} style={{ height: '100%' }}>
            {props.fields && props.fields.length > 0 && (
                <CustomFilters
                    ref={customFiltersRef}
                    allowEmptyConditions={true}
                    conditions={list}
                    fields={props.fields}
                    fieldValueSettings={props.fieldValueSettings}
                    theme="bootstrap"
                    onChanged={filterContidionChanged}
                    fieldSelectorClass="form-control input-sm"
                    operatorSelectorClass="form-control input-sm"
                    languageCode={props.sdkOptions.props.language}
                    fieldNameField="key"
                    fieldKeyField="key"
                    fieldTextField="label"
                    showConditionNumber={true}
                    postfixComponentRenderInLine={props.postfixComponentRenderInLine}
                    conditionPostfixComponent={props.conditionPostfixComponent}
                    operatorsFilter={props.operatorsFilter}
                    isAutoHideOperator={props.isAutoHideOperator}
                />
            )}
        </div>
    );
};
const CustomInfo = (props) => {
    let [customDataSourceList, setCustomDataSourceList] = useState(
        props.customDataSourceList || []
    );
    let [filterKeyWord, setFilterKeyWord] = useState('');
    useEffect(() => {
        setCustomDataSourceList(props.customDataSourceList);
    }, [props]);
    return (
        <div>
            <Input.Search
                placeholder={props.locales.filterPlaceholder}
                onChange={(e) => {
                    !e.target.value && setFilterKeyWord('');
                }}
                onSearch={(value) => setFilterKeyWord(value)}
            ></Input.Search>
            {customDataSourceList && customDataSourceList.length > 0 && (
                <Collapse
                    bordered={false}
                    expandIconPosition="right"
                    defaultActiveKey={customDataSourceList
                        .filter((item, index) => index < 3)
                        .map((item) => item.id)}
                >
                    {customDataSourceList &&
                        customDataSourceList.length > 0 &&
                        customDataSourceList.map((item) => {
                            let fieldList = [];
                            if (item.fieldList && item.fieldList.length > 0) {
                                fieldList = item.fieldList.filter((items) =>
                                    filterKeyWord ? items.label.includes(filterKeyWord) : true
                                );
                            }
                            if (!fieldList.length) return null;
                            return (
                                <Panel
                                    header={<div className="panel-header-title">{item.name}</div>}
                                    key={item.id}
                                >
                                    <div>
                                        {fieldList.map((items, index) => {
                                            return (
                                                <DraggableComponent
                                                    key={`${items.id}-${index}`}
                                                    id={items.id}
                                                    name={items.label}
                                                    fieldType={items.fieldType}
                                                />
                                            );
                                        })}
                                    </div>
                                </Panel>
                            );
                        })}
                </Collapse>
            )}
        </div>
    );
};
export default class CustomFilterModalTemplate extends CustomFilterModalComponent {
    render() {
        let {
            sdkOptions,
            customTypeList,
            businessFlag,
            conditionPostfixComponent,
            postfixComponentRenderInLine,
            operatorsFilter,
            isAutoHideOperator,
        } = this.props;

        let {
            displayConditionList,
            customeFilterFieldKey,
            customType,
            customName,
            customFilterList,
            customeFilterField,
            customDataSourceList,
            myDropTargetRef,
        } = this.privates;

        let { _fields, _fieldValueSettings } = this.privates.computes;

        let { actions, locales } = this;

        let footerButton = (
            <div>
                {customType === customTypeList.customTypeShow && (
                    <div>
                        <If
                            condition={
                                Udesk.data.init.user && Udesk.data.init.user.hasFeature('st:delete')
                            }
                        >
                            <Button onClick={actions.handleConditionDel}>
                                {locales.components.common.customFilter.del}
                            </Button>
                        </If>
                        <If
                            condition={
                                Udesk.data.init.user && Udesk.data.init.user.hasFeature('st:edit')
                            }
                        >
                            <Button onClick={actions.handleConditionEdit}>
                                {locales.components.common.customFilter.edit}
                            </Button>
                        </If>
                        <If condition={!businessFlag}>
                            <Button type="primary" onClick={actions.handleConditionApplyField}>
                                {locales.components.common.customFilter.apply}
                            </Button>
                        </If>
                    </div>
                )}
                {customType === customTypeList.customTypeEdit && (
                    <div>
                        <Button onClick={actions.handleConditionCancel}>
                            {locales.components.common.customFilter.cancel}
                        </Button>
                        <If condition={!businessFlag}>
                            <Button
                                type={customName ? 'default' : 'primary'}
                                onClick={actions.handleConditionApply}
                            >
                                {locales.components.common.customFilter.onlyApply}
                            </Button>
                        </If>

                        <If
                            condition={
                                Udesk.data.init.user && Udesk.data.init.user.hasFeature('st:add')
                            }
                        >
                            {/* <If condition={!businessFlag}>
                                    <Button onClick={actions.handleConditionOtherSave}>{locales.components.common.customFilter.ohterSave}</Button>
                                </If> */}
                            <Button
                                type={!customName ? 'default' : 'primary'}
                                onClick={actions.handleConditionSave}
                            >
                                {locales.components.common.customFilter.save}
                            </Button>
                        </If>
                    </div>
                )}
            </div>
        );

        let filterTitle = (
            <div className="custom-filter-modal-title-node">
                <div className="custom-filter-modal-title-node-left-info">
                    <Tabs activeKey={`${customType}`} onChange={actions.customStaus}>
                        <TabPane
                            tab={
                                <span>
                                    {/* 自定义排序 */}
                                    {
                                        UdeskLocales['current'].components.customSortModal.template
                                            .customSort
                                    }
                                </span>
                            }
                            key={1}
                        ></TabPane>
                        <TabPane
                            tab={
                                <span>
                                    {/* 常用排序 */}
                                    {
                                        UdeskLocales['current'].components.customSortModal.template
                                            .commonSort
                                    }
                                </span>
                            }
                            key={2}
                        ></TabPane>
                    </Tabs>
                    {/* {
                        customType === customTypeList.customTypeEdit && (<span className='custom-filter-modal-titile-node-left-info-title'>{customEdit ? `${locales.components.common.customFilter.edit}` : `${locales.components.common.customFilter.new}`}</span>)
                    }
                    {
                        customType === customTypeList.customTypeShow && (<span className='custom-filter-modal-titile-node-left-info-title' onClick={actions.customStaus.params(1)}>
                            <i className="udesk-qa-react-web-iconfont icon-udesk-qa-react-web-jiantou2"></i>
                            {locales.components.common.customFilter.customFilter}
                        </span>)
                    }
                    {
                        customType === customTypeList.customTypeEdit && (<span className='custom-filter-modal-titile-node-left-info-action' onClick={actions.customStaus.params(2)}>{locales.components.common.customFilter.customFilter}</span>)
                    } */}
                </div>
                <div className="custom-filter-modal-title-node-right-action">
                    <Button onClick={actions.reset}>
                        {locales.components.common.customFilter.reset}
                    </Button>
                </div>
            </div>
        );

        console.log(
            'sort',
            displayConditionList,
            customeFilterField,
            customFilterList,
            customDataSourceList
        );

        return (
            <Modal
                visible={this.props.visible}
                title={filterTitle}
                footer={footerButton}
                wrapClassName="sort-custom-filters"
                onCancel={actions.handleConditionCancel}
                destroyOnClose
                maskStyle={{ transition: 'none' }}
            >
                <DndProvider backend={HTML5Backend}>
                    <div className="react-qa-custom-filters-body">
                        {/* 自定义排序 */}
                        <div
                            className="react-qa-custom-filter-body-left-info"
                            style={{
                                display:
                                    customType === customTypeList.customTypeEdit ? 'block' : 'none',
                            }}
                        >
                            <div>
                                <div>
                                    <CustomInfo
                                        customDataSourceList={customDataSourceList}
                                        filterFieldList={actions.filterFieldList}
                                        locales={locales.components.common.customFilter}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* 常用排序 */}
                        <div
                            className="custom-fiter-custom-type-show"
                            style={{
                                display:
                                    customType === customTypeList.customTypeShow ? 'block' : 'none',
                            }}
                        >
                            <div style={{ padding: '10px 16px 10px 0' }}>
                                <Input.Search
                                    placeholder={
                                        locales.components.common.customFilter.holderKeyWord
                                    }
                                    onChange={actions.customInputSearchChange}
                                    onSearch={actions.customInputSearch}
                                />
                            </div>
                            <Menu
                                mode="vertical"
                                theme="light"
                                selectedKeys={customeFilterFieldKey}
                                style={{ width: '210px', height: '100%' }}
                                onClick={actions.menuKeysChange}
                            >
                                {customFilterList &&
                                    customFilterList.length > 0 &&
                                    customFilterList
                                        .filter((item) => item.usable)
                                        .map((item, index) => {
                                            return (
                                                <Menu.Item
                                                    key={`${item.id}-${index}`}
                                                    disabled={!item.status}
                                                >
                                                    {item.name}
                                                </Menu.Item>
                                            );
                                        })}
                            </Menu>
                        </div>

                        <div className="react-qa-custom-filter-body-right-info">
                            <div className="react-qa-custom-filter-body-right-info-field">
                                <div className="react-qa-custom-filter-body-right-info-title">
                                    <Space>
                                        <span className="react-qa-custom-filter-body-right-info-title-name">
                                            {/* 排序器名称: */}
                                            {
                                                UdeskLocales['current'].components.customSortModal
                                                    .template.sorterName
                                            }
                                        </span>
                                        {customType === customTypeList.customTypeEdit && (
                                            <Input
                                                value={customName}
                                                onChange={actions.customInputChange}
                                                showCount={true}
                                                maxCount={500}
                                                maxLength={500}
                                                placeholder={
                                                    /* 请输入排序器名称 */ UdeskLocales['current']
                                                        .components.customSortModal.template
                                                        .pleaseEnterASorterName
                                                }
                                                style={{ width: '200px' }}
                                            />
                                        )}
                                        {customType === customTypeList.customTypeShow && (
                                            <Ellipsis
                                                text={
                                                    !_isEmpty(customeFilterField)
                                                        ? customeFilterField.name
                                                        : ''
                                                }
                                            />
                                        )}
                                    </Space>
                                </div>

                                {/* 自定义排序 */}
                                <div
                                    style={{
                                        height: 'calc(100% - 32px)',
                                        display:
                                            customType === customTypeList.customTypeEdit
                                                ? 'block'
                                                : 'none',
                                    }}
                                >
                                    <MyDropTarget
                                        postfixComponentRenderInLine={postfixComponentRenderInLine}
                                        conditionPostfixComponent={conditionPostfixComponent}
                                        operatorsFilter={operatorsFilter}
                                        isAutoHideOperator={isAutoHideOperator}
                                        refField={myDropTargetRef}
                                        filterContidionChange={actions.filterContidionChanged}
                                        displayConditionList={displayConditionList}
                                        fields={_fields}
                                        fieldValueSettings={_fieldValueSettings}
                                        sdkOptions={sdkOptions}
                                    />
                                </div>

                                {/* 常用排序 */}
                                {customType === customTypeList.customTypeShow &&
                                    !_isEmpty(customeFilterField) &&
                                    this.actions.fieldsFilterChange(customeFilterField)}
                            </div>
                        </div>
                    </div>
                </DndProvider>
            </Modal>
        );
    }
}
